import React, { createContext, useContext, useEffect, useState } from 'react';
import axios from 'axios';
import { useAuth } from './AuthContext';
import { DEFAULT_ROLE_PERMISSIONS } from '../config/permissions';
import API_URL from '../api/baseURL';

const PermissionsContext = createContext();

export const PermissionsProvider = ({ children }) => {
    const { user, token } = useAuth();
    const [permissions, setPermissions] = useState([]);
    const [isAdmin, setIsAdmin] = useState(false);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (!user || !user.role) {
            setPermissions([]);
            setLoading(false);
            return;
        }

        setIsAdmin(user.role === 'Admin');

        const fetchPermissions = async () => {
            try {
                // First, apply defaults immediately for fast load
                const defaults = DEFAULT_ROLE_PERMISSIONS[user.role] || [];
                setPermissions(defaults);

                // Then try to fetch dynamic overrides from backend
                if (token) {
                    const res = await axios.get(`${API_URL}/permissions/my`, {
                        headers: { Authorization: `Bearer ${token}` }
                    });

                    if (res.data && res.data.features && res.data.features.length > 0) {
                        setPermissions(res.data.features);
                    }
                }
            } catch (err) {
                console.error("Failed to fetch dynamic permissions, using defaults", err);
            } finally {
                setLoading(false);
            }
        };

        fetchPermissions();
    }, [user, token]);

    const hasPermission = (feature) => {
        if (isAdmin) return true; // Admins see everything
        return permissions.includes(feature);
    };

    return (
        <PermissionsContext.Provider value={{ permissions, hasPermission, loading, isAdmin }}>
            {children}
        </PermissionsContext.Provider>
    );
};

export const usePermissions = () => useContext(PermissionsContext);
